{
  "status": {
    "pending": "लंबित",
    "preliminary": "प्रारंभिक",
    "final": "अंतिम",
    "corrected": "संशोधित",
    "amended": "पूरक",
    "addended": "परिशिष्ट जोड़ा गया",
    "enteredInError": "प्रविष्टि त्रुटि",
    "unknown": "अज्ञात"
  },
  "review": {
    "title": "परिणाम समीक्षा",
    "printLabel": "परिणाम मुद्रित करें",
    "summary": {
      "count_one": "{{count}} परिणाम",
      "count_other": "{{count}} परिणाम",
      "criticalUnacknowledged": "{{count}} गंभीर मान अस्वीकृत"
    },
    "view": {
      "timeline": "समयरेखा",
      "flowsheet": "फ़्लोशीट"
    },
    "filter": {
      "date": "तिथि",
      "type": "प्रकार",
      "status": "स्थिति",
      "statusAll": "सभी"
    },
    "dateRange": {
      "h24": "पिछले 24 घंटे",
      "h48": "पिछले 48 घंटे",
      "d7": "पिछले 7 दिन",
      "d30": "पिछले 30 दिन",
      "all": "सभी"
    },
    "resultType": {
      "all": "सभी",
      "lab": "प्रयोगशाला",
      "imaging": "इमेजिंग",
      "pathology": "विकृति विज्ञान",
      "cardiology": "हृदय रोग",
      "microbiology": "सूक्ष्मजीव विज्ञान"
    },
    "criticalOnlyToggle": "केवल गंभीर",
    "criticalBadge": "गंभीर",
    "actions": {
      "acknowledgeCritical": "गंभीर मान स्वीकार करें",
      "acknowledgeAllCritical": "सभी गंभीर परिणाम स्वीकार करें ({{count}})"
    },
    "detail": {
      "resultNumber": "परिणाम संख्या",
      "performingProviderId": "करने वाले चिकित्सक की ID",
      "verifiedByProviderId": "सत्यापन चिकित्सक की ID",
      "verifiedAt": "सत्यापन समय",
      "specimenCollected": "नमूना संग्रह समय",
      "clinicalSignificance": "चिकित्सकीय महत्व",
      "recommendations": "अनुशंसाएँ",
      "report": "रिपोर्ट",
      "addendum": "परिशिष्ट",
      "criticalAcknowledged": "गंभीर मान स्वीकृत",
      "providerHash": "चिकित्सक #{{id}}",
      "acknowledgedAt": " समय {{when}}",
      "specimenType": "नमूना प्रकार",
      "grossDescription": "स्थूल विवरण",
      "microscopicDescription": "सूक्ष्मदर्शी विवरण",
      "accessionNumber": "एक्सेशन संख्या",
      "bodyRegion": "शरीर क्षेत्र",
      "studyInstanceUid": "स्टडी इंस्टेंस UID",
      "cardiologyMeasurements": "माप",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "परिणाम लोड हो रहे हैं…",
    "loadError": "परिणाम लोड करने में विफल। कृपया पुनः प्रयास करें।",
    "empty": "चयनित फ़िल्टर के लिए कोई परिणाम नहीं मिला।",
    "toast": {
      "acknowledgeSuccess": "गंभीर परिणाम स्वीकृत किया गया",
      "acknowledgeError": "परिणाम स्वीकार करने में विफल"
    },
    "susceptibility": {
      "title": "जीवाणु एवं संवेदनशीलता",
      "antibiotic": "एंटीबायोटिक",
      "interpretation": "व्याख्या",
      "mic": "MIC",
      "unnamedOrganism": "अनाम जीवाणु",
      "noPanel": "इस जीवाणु के लिए कोई संवेदनशीलता परिणाम रिपोर्ट नहीं किया गया।"
    },
    "components": {
      "value": "मान",
      "referenceRange": "संदर्भ सीमा"
    }
  },
  "pending": {
    "title": "लंबित परिणाम",
    "countBadge_one": "{{count}} लंबित",
    "countBadge_other": "{{count}} लंबित",
    "autoRefresh": "स्वतः रीफ्रेश {{seconds}} सेकंड",
    "updated": "अद्यतन {{when}}",
    "searchPlaceholder": "रोगी का नाम, MRN या आदेश से खोजें…",
    "filtersButton": "फ़िल्टर",
    "fields": {
      "orderType": "आदेश प्रकार",
      "allTypes": "सभी प्रकार",
      "priority": "प्राथमिकता",
      "allPriorities": "सभी प्राथमिकताएँ",
      "dateFrom": "तिथि से",
      "dateTo": "तिथि तक"
    },
    "orderType": {
      "lab": "प्रयोगशाला",
      "imaging": "इमेजिंग",
      "procedure": "प्रक्रिया",
      "consultation": "परामर्श",
      "laboratory": "प्रयोगशाला",
      "radiology": "रेडियोलॉजी",
      "surgery": "शल्य चिकित्सा",
      "therapy": "उपचार",
      "medication": "दवा",
      "admission": "भर्ती"
    },
    "aria": {
      "dateFrom": "लंबित परिणाम तिथि से",
      "dateTo": "लंबित परिणाम तिथि तक"
    },
    "columns": {
      "patient": "रोगी",
      "mrn": "MRN",
      "order": "आदेश",
      "type": "प्रकार",
      "orderedBy": "आदेश देने वाले",
      "ordered": "आदेश समय",
      "expected": "अपेक्षित समय",
      "priority": "प्राथमिकता"
    },
    "loading": "लंबित परिणाम लोड हो रहे हैं…",
    "loadError": "लंबित परिणाम लोड करने में विफल",
    "retry": "पुनः प्रयास",
    "empty": "कोई लंबित परिणाम नहीं मिला।",
    "awaitingResult": "परिणाम की प्रतीक्षा",
    "specimenReceived": "नमूना प्राप्त",
    "inLab": "प्रयोगशाला में",
    "cancelledByLab": "प्रयोगशाला द्वारा रद्द",
    "overdue": "देय तिथि बीती",
    "expectedBy": "{{date}} तक अपेक्षित"
  },
  "critical": {
    "title": "गंभीर परिणाम",
    "autoRefresh": "स्वतः रीफ्रेश {{seconds}} सेकंड",
    "updated": "अद्यतन {{when}}",
    "unacknowledgedHeading_one": "{{count}} अस्वीकृत गंभीर मान",
    "unacknowledgedHeading_other": "{{count}} अस्वीकृत गंभीर मान",
    "escalationBanner": "इन परिणामों को चिकित्सक से तत्काल स्वीकृति की आवश्यकता है।",
    "acknowledgeWithinMinutes": "{{minutes}} मिनट के भीतर स्वीकार करें",
    "routeBackToProvider": "आदेश देने वाले चिकित्सक को वापस भेजें",
    "attendingSignoff": "उपस्थित चिकित्सक के हस्ताक्षर आवश्यक",
    "searchPlaceholder": "रोगी या परीक्षण के नाम से खोजें…",
    "showAcknowledgedToggle": "स्वीकृत दिखाएँ",
    "escalationTime": "T+{{minutes}} मि",
    "criticalFallback": "गंभीर",
    "loading": "गंभीर परिणाम लोड हो रहे हैं…",
    "loadError": "गंभीर परिणाम लोड करने में विफल",
    "empty": "स्वीकृति के लिए कोई गंभीर परिणाम लंबित नहीं।",
    "detailToggleLabel": "परिणाम विवरण दिखाएँ",
    "openFullChart": "पूरा चार्ट खोलें",
    "columns": {
      "patient": "रोगी",
      "mrn": "MRN",
      "test": "परीक्षण",
      "value": "मान",
      "impression": "मत",
      "resultTime": "परिणाम समय",
      "escalation": "वृद्धि",
      "acknowledged": "स्वीकृत",
      "actions": "क्रियाएँ"
    },
    "actions": {
      "acknowledge": "स्वीकार करें"
    },
    "toast": {
      "acknowledgeSuccess": "गंभीर परिणाम स्वीकृत किया गया",
      "acknowledgeError": "परिणाम स्वीकार करने में विफल"
    },
    "refreshFailed": "रीफ़्रेश नहीं हो सका — {{when}} तक के गंभीर परिणाम दिखाए जा रहे हैं।",
    "incomplete": "{{total}} गंभीर परिणामों में से {{shown}} दिखाए जा रहे हैं। यह सूची अधूरी है।"
  },
  "acknowledged": {
    "pending": "स्वीकृति लंबित",
    "acknowledged": "स्वीकृत",
    "escalated": "उच्च स्तर पर भेजा गया",
    "expired": "स्वीकृति अवधि समाप्त"
  },
  "flowsheet": {
    "analyte": "विश्लेष्य",
    "empty": "प्रवृत्ति दिखाने के लिए कोई प्रयोगशाला विश्लेष्य नहीं",
    "emptyHint": "इमेजिंग, पैथोलॉजी और सूक्ष्मजीव रिपोर्ट टाइमलाइन दृश्य में दिखती हैं।",
    "trend": {
      "toggle": "{{analyte}} की प्रवृत्ति",
      "referenceRange": "संदर्भ {{range}}",
      "nonNumericOmitted_one": "{{count}} पाठ परिणाम प्लॉट नहीं किया गया",
      "nonNumericOmitted_other": "{{count}} पाठ परिणाम प्लॉट नहीं किए गए"
    }
  }
}
